module.exports = __webpack_public_path__ + "app/principal/widgets/modify-button-GSg9M7vX.html";